import gsap from 'gsap';

import { EarthRef } from '0_canvas/Earth/Earth';
import promiseTimeline from 'utils/promiseTimeline';

import { AUSTRALIA_ROTATION } from './EarthScene.utils';

export const earthRevealAnimation = (earthRef: EarthRef) =>
  promiseTimeline(earthRef.earth.current?.position, {
    y: -0,
    duration: 3,
    ease: 'power2.Out',
  });

export const centerAnimation = (earthRef: EarthRef) =>
  promiseTimeline(earthRef.earth.current?.position, {
    y: 0,
    duration: 2,
    ease: 'power2.out',
  });

export const rotateToAustralia = (
  earthRef: EarthRef,
  beforeFinished: () => void
) => {
  if (!earthRef.earth.current?.rotation) return;
  gsap.killTweensOf(earthRef.earth.current?.rotation);
  gsap
    .timeline()
    .to(earthRef.earth.current?.rotation, {
      ...AUSTRALIA_ROTATION,
      ease: 'power2.out',
      duration: 3,
    })
    .call(beforeFinished, [], '>-2');
};

export const rotateEarth = (ref: EarthRef) =>
  ref.earth.current?.rotation &&
  gsap.to(ref.earth.current?.rotation, {
    y: '+=' + Math.PI * 2,
    duration: 80,
    ease: 'none',
    repeat: -1,
  });
